<template>
  <b-row class="border rounded">
    <b-col sm="2" md="1">
      <b-form-checkbox
        class="m-1"
        size="lg"
        v-model="item.value.included"
        :disabled="item.value.required"
      />
    </b-col>
    <b-col sm="5" md="4">
      <b-form-input
        class="m-1"
        :placeholder="item.text"
        :state="item.value.required ? item.value.csv_key != null : null"
        disabled
      />
    </b-col>
    <b-col sm="5" md="4">
      <b-form-select
        class="m-1"
        :state="item.value.required ? item.value.csv_key != null : null"
        v-model="item.value.csv_key"
        :options="header_row"
        :disabled="!item.value.included"
      />
    </b-col>
    <b-col sm="12" md="3">
      <b-form-input class="m-1" :placeholder="preview" disabled />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    header_row: Array,
    data_row: Array,
    item: {
      type: Object,
      default: () => {
        return {
          text: "",
          value: {
            model_key: "",
            csv_key: null,
            required: false,
            included: false
          }
        };
      }
    }
  },
  data() {
    return {
      preview: ""
    };
  },
  methods: {
    update_preview() {
      let index = this.header_row.indexOf(this.item.value.csv_key);
      this.preview = this.data_row[index];
    }
  },
  watch: {
    "item.value.csv_key": function() {
      this.update_preview();
    },
    "item.value.included": function(included) {
      if (!included) {
        this.item.value.csv_key = null;
        this.preview = "";
      }
    },
    data_row: function() {
      this.update_preview();
    }
  }
};
</script>
